import { render, staticRenderFns } from "./NccQuestionHeader.vue?vue&type=template&id=592f7a8b&scoped=true&"
import script from "./NccQuestionHeader.vue?vue&type=script&lang=js&"
export * from "./NccQuestionHeader.vue?vue&type=script&lang=js&"
import style0 from "./NccQuestionHeader.vue?vue&type=style&index=0&id=592f7a8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f7a8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('592f7a8b')) {
      api.createRecord('592f7a8b', component.options)
    } else {
      api.reload('592f7a8b', component.options)
    }
    module.hot.accept("./NccQuestionHeader.vue?vue&type=template&id=592f7a8b&scoped=true&", function () {
      api.rerender('592f7a8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccQuestionHeader.vue"
export default component.exports